import React from 'react';
import {Show, SimpleShowLayout, TextField} from 'react-admin';
import CashbackItemsField from './CashbackItemsField';

class CashbackConditionsShow extends React.Component {
    render() {
        return (
            <Show {...this.props}>
                <SimpleShowLayout>
                    <TextField source="id" addLabel={true} />
                    <TextField source="position" addLabel={true} />
                    <TextField source="margin" addLabel={true} />
                    <TextField source="fontSize" label="Font Size" />
                    <CashbackItemsField />
                </SimpleShowLayout>
            </Show>
        );
    }
}

export default CashbackConditionsShow;
